const options = {
    grabCursor: true,
    keyboard: true,
    navigation: {
        prevEl: '.js-partner-teaser-prev',
        nextEl: '.js-partner-teaser-next',
    },
    spaceBetween: 10,
    slidesPerView: 2,
    breakpoints: {
        485: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 5,
            spaceBetween: 10,
        },
        1200: {
            slidesPerView: 7,
            spaceBetween: 10,
        },
    },
};

const secondOptions = {
    grabCursor: true,
    keyboard: true,
    spaceBetween: 10,
    slidesPerView: 1.75,
    navigation: {
        prevEl: '.js-more-partner-teaser-prev',
        nextEl: '.js-more-partner-teaser-next',
    },
    breakpoints: {
        485: {
            slidesPerView: 2.25,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 10,
        },
        1200: {
            slidesPerView: 7,
            spaceBetween: 10,
        },
    },
};

const sliderPartnerTeaser = {
    init() {
        const elements = document.querySelectorAll('.js-slider-partner-teaser');

        if (!elements.length) return;

        elements.forEach((element) => {
            if (element.dataset.sPerView) {
                options.slidesPerView = parseFloat(element.dataset.sPerView);
            }

            if (window.innerWidth > 768 && element.dataset.sMobileOnly === '1') return;

            const Slider = slider.default;
            this.sliderPartnerTeaser = new Slider(element, options);
        });

        const morePartners = document.querySelectorAll('.js-slider-more-partner-teaser');

        if (!morePartners.length) return;

        morePartners.forEach((element) => {
            if (element.dataset.sPerView) {
                options.slidesPerView = parseFloat(element.dataset.sPerView);
            }

            if (window.innerWidth > 768 && element.dataset.sMobileOnly === '1') return;

            const Slider = slider.default;
            this.sliderPartnerTeaser = new Slider(element, secondOptions);
        });
    },
};

export default sliderPartnerTeaser;
